module.exports = __webpack_public_path__ + "2b84bb495ee2d0d39c4b743067bd7fdd.png";